import React, { useState, useEffect } from 'react';
import RedirectOverlay from './RedirectOverlay';

/**
 * PersistentOverlayManager - Manages overlay state that persists across page navigation
 * This component handles the overlay state that should remain visible during Microsoft authentication
 */
const PersistentOverlayManager = () => {
    const [showOverlay, setShowOverlay] = useState(false);
    const [overlayType, setOverlayType] = useState('loading');
    const [overlayMessage, setOverlayMessage] = useState('Vă conectăm la Microsoft Entra ID...');

    // Check if we should show overlay based on URL parameters or session storage
    useEffect(() => {
        // Check URL parameters for overlay trigger
        const urlParams = new URLSearchParams(window.location.search);
        const showOverlayParam = urlParams.get('showOverlay');
        const isLogout = urlParams.get('logout');

        // If this is a logout redirect, clear overlay and don't show it
        if (isLogout === 'true') {
            setShowOverlay(false);
            sessionStorage.removeItem('redirectOverlay');
            return;
        }

        // Check session storage for overlay state (persists across redirects)
        const storedOverlay = sessionStorage.getItem('redirectOverlay');

        if (showOverlayParam === 'true' || storedOverlay === 'true') {
            setShowOverlay(true);
            setOverlayType('loading');
            setOverlayMessage('Vă conectăm la Microsoft Entra ID...');

            // Set in session storage to persist across redirects
            sessionStorage.setItem('redirectOverlay', 'true');
        } else {
            // Clear overlay if not needed
            setShowOverlay(false);
            sessionStorage.removeItem('redirectOverlay');
        }
    }, []);

    // Function to trigger overlay before Microsoft redirect
    const triggerMicrosoftOverlay = () => {
        setShowOverlay(true);
        setOverlayType('loading');
        setOverlayMessage('Vă conectăm la Microsoft Entra ID...');

        // Store in session storage to persist across redirects
        sessionStorage.setItem('redirectOverlay', 'true');

        // Return true to indicate overlay is active
        return true;
    };

    // Function to clear overlay after authentication completes
    const clearOverlay = () => {
        setShowOverlay(false);
        sessionStorage.removeItem('redirectOverlay');
    };

    // Provide the trigger function to window object so it can be called from other components
    useEffect(() => {
        window.triggerMicrosoftOverlay = triggerMicrosoftOverlay;
        window.clearRedirectOverlay = clearOverlay;
    }, []);

    return (
        <RedirectOverlay
            show={showOverlay}
            userName="utilizator"
            message={overlayMessage}
            type={overlayType}
        />
    );
};

export default PersistentOverlayManager;
